import { AdgroupFormData } from '@tt4b/ttam-enums';
import { computed, ref, Ref } from '@vue/composition-api';
import { convertContentToStr } from './../../../utils/index';

export function useShowBatchEditText(opt: { showBatchEdit: Ref<boolean>; copyNum: Ref<number> }) {
  return {
    isShowBatchEdit: computed(() => opt.showBatchEdit.value && opt.copyNum.value > 1),
  };
}

export function useFieldMixed(opt: {
  fields: Ref<(keyof AdgroupFormData)[]>;
  adgroupData: Ref<AdgroupFormData>;
  batchFormData: Ref<Partial<AdgroupFormData>[]>;
}) {
  const isFieldMixed = computed(() => {
    let isMixed = false;
    if (opt.batchFormData.value.length) {
      opt.fields.value.forEach(field => {
        const firstItem = opt.batchFormData.value?.[0]?.[field] ?? opt.adgroupData.value?.[field];
        const allSame = opt.batchFormData.value.every((item, index) => {
          if (field === 'name') {
            return item[field] === `${opt.adgroupData.value.name}-${index + 1}`;
          }
          const value = item[field] ?? opt.adgroupData.value?.[field];
          return convertContentToStr(value) === convertContentToStr(firstItem);
        });
        if (!allSame) {
          isMixed = true;
        }
      });
    }
    return isMixed;
  });

  return {
    isFieldMixed,
  };
}

export function useShowBatchEditModal() {
  const batchEditFields = ref<(keyof AdgroupFormData)[]>([]);
  const batchEditModalVisible = ref(false);
  const batchEditLabel = ref('');
  const openBatchEditor = (fields: (keyof AdgroupFormData)[], label: string) => {
    batchEditFields.value = fields;
    batchEditLabel.value = label;
    batchEditModalVisible.value = true;
  };

  const closeBatchEditor = () => {
    batchEditFields.value = [];
    batchEditLabel.value = '';
    batchEditModalVisible.value = false;
  };

  return {
    batchEditFields,
    batchEditModalVisible,
    batchEditLabel,
    openBatchEditor,
    closeBatchEditor,
  };
}
